// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"190":"a64680ae","538":"a5bef68b","566":"b6871221","945":"b43b0ba4"}[chunkId] + ".chunk.js";
};